import React from 'react';

import { resolvers } from '@candu-ai/editor-nodes/richtext-resolvers';

export const Element = (props: any) => {
  const { element } = props;

  const Component = resolvers[element.type] || resolvers.Typography;
  return <Component {...props} />;
};
